export default {
  /** ---------接口配置模块--------- */
  // 创建文档库
  createDocPlatform: '/gateway/api/doc/platform/create/',
  // 更新文档库
  updateDocPlatform: '/gateway/api/doc/platform/update/',
  // 更新文档树
  updateDocTree: '/gateway/api/doc/platform/tree/update/',
  // 删除文档库
  deleteDocPlatform: '/gateway/api/doc/platform/delete/',
  // 获取文档库的列表
  getDocPlatformList: '/gateway/api/doc/platform/get/',
  // 发布文档
  releaseDocPlatform: '/gateway/api/doc/platform/release/',
  // 创建文档
  createNewDoc: '/gateway/api/doc/node/create/',
  // 获取文档树
  getDocPlatformTree: '/gateway/api/doc/platform/tree/get/',
  // 获取文档内容
  getDocContext: '/gateway/api/doc/node/get/',
  // 更新文档内容
  updateDocInfo: '/gateway/api/doc/node/update/',
  // 更改多语言文档内容
  updateMultiDocInfo: '/gateway/api/doc/node/translation/update/',
  // 文档发布文档
  docRelease: '/gateway/api/doc/node/release/',
  // 文档上线
  docOnline: '/gateway/api/doc/node/online/',
  // 文档下线
  docOffline: '/gateway/api/doc/node/offline/',
  // 删除文档
  deleteDoc: '/gateway/api/doc/node/delete/',
  // api接口查询
  getApiList: '/gateway/api/interface/query/',
  // 文件上传
  uploadFile: '/gateway/api/common/file/upload/',
  // 预览API文档的内容
  previewAPIContent: '/gateway/api/interface/mdContent/get/',
};

// 接口文档  https://bytedance.feishu.cn/docs/doccnEtH5PpNjKNrmhuGwq1ioOc#
// 多余配置的文档 https://bytedance.feishu.cn/docs/doccnEzEgirKKh9mKefjjdYkhMc
